import React from 'react'
import { Box, Chip, Typography } from '@mui/material'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'

const formatDate = date => {
	const raw = String(date)
	return `${raw.slice(6, 8)}/${raw.slice(4, 6)}/${raw.slice(0, 4)}`
}

const buildWindow = (columns = []) => {
	const dates = columns.filter(Boolean)

	if (!dates.length) return null
	if (dates.length === 1) return formatDate(dates[0])

	return `${formatDate(dates[0])} – ${formatDate(dates[dates.length - 1])}`
}

/**
 * Context the filter bar does not already state: which brand everything is
 * measured against, the pickup window covered and how many rivals are tracked.
 */
export default function PositionContext({ mainName, office, columns, totalBrands, currency }) {
	if (isAnalyzerLoading.value) return null

	const window = buildWindow(columns)
	const competitors = totalBrands > 1 ? totalBrands - 1 : null

	const chips = [
		{ key: 'office', label: 'Office', value: office?.name },
		{ key: 'window', label: 'Window', value: window },
		{ key: 'competitors', label: 'Competitors', value: competitors ? `${competitors} tracked` : null },
		{ key: 'currency', label: 'Currency', value: currency },
	].filter(({ value }) => !!value)

	if (!mainName && !chips.length) return null

	return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
		{!!mainName && <Chip
			variant="outlined"
			size="small"
			sx={{ borderColor: 'primary.main', backgroundColor: 'primary.lighter' }}
			label={<Box sx={{ display: 'flex', gap: .5 }}>
				<Typography variant="caption" sx={{ color: 'text.secondary' }}>Brand</Typography>
				<Typography variant="caption" sx={{ fontWeight: 'bold', color: 'primary.dark' }}>{mainName}</Typography>
			</Box>}
		/>}

		{chips.map(({ key, label, value }) => <Chip
			key={key}
			variant="outlined"
			size="small"
			label={<Box sx={{ display: 'flex', gap: .5 }}>
				<Typography variant="caption" sx={{ color: 'text.secondary' }}>{label}</Typography>
				<Typography variant="caption" sx={{ fontWeight: 'bold' }}>{value}</Typography>
			</Box>}
		/>)}
	</Box>
}
